export default "__VITE_ASSET__DkrPbQOH__"